export default {
	menuAnimateIn: null,
	menuOpen: false,
	init() {
		if (!document.querySelector("li.has-children")) {
			return;
		}
		const menuButton = document.querySelector("#menu-button");
		const mobileMenu = window.matchMedia("(max-width: 991px)");
		const backButton = document.querySelector(".sub-nav--back-button");

		menuButton.addEventListener("click", () => {
			document.querySelector("body").classList.toggle("menu-open");
			setTimeout(function () {
				document.querySelectorAll("li.has-children").forEach((item) => {
					item.classList.remove("is-active");
				});
			}, 0.3);
		});

		backButton.addEventListener("click", (e) => {
			e.stopPropagation();

			document.querySelectorAll("li.has-children").forEach((item) => {
				item.classList.remove("is-active");
			});
		});

		document.querySelectorAll("li.has-children").forEach((item) => {
			const link = item.querySelector(":scope > a");

			item.addEventListener("mouseenter", () => {
				if (!mobileMenu.matches) {
					item.classList.add("is-active");
				}
			});

			item.addEventListener("mouseleave", () => {
				if (!mobileMenu.matches) {
					item.classList.remove("is-active");
				}
			});

			item.addEventListener("click", (e) => {
				if (mobileMenu.matches) {
					item.classList.add("is-active");
				}
			});
		});
	},
	destroy() {
		setTimeout(function () {
			document.querySelectorAll("li.has-children").forEach((item) => {
				item.classList.remove("is-active");
			}, 300);
		});
	},
};
